export default __webpack_public_path__ + "static/media/obtain_tiny_hero.84b66da1.png";